import TemplateView from "../../TemplateView";

export default class InfoContent extends TemplateView {
    templateHtml(){
        return '<div class="infoContainer">' +
               '    <div class="infoSentence"><%-infoTextFirstSentencePart1%> <%=infoTextFirstSentencePart2%></div>' +
               '    <div class="infoSentence"><%-infoTextSecondSentencePart1%> <%=infoTextSecondSentencePart2%> <%-infoTextSecondSentencePart3%></div>' +
               '    <div class="infoSentence"><%-infoTextThirdSentence%></div>' +
               '</div>'
    }

    messageKeys(){
        return {
            infoTextFirstSentencePart1: "workflow_settings.info_text.sentence_1.part1",
            infoTextFirstSentencePart2: "workflow_settings.info_text.sentence_1.part2",
            infoTextSecondSentencePart1: "workflow_settings.info_text.sentence_2.part1",
            infoTextSecondSentencePart2: "workflow_settings.info_text.sentence_2.part2",
            infoTextSecondSentencePart3: "workflow_settings.info_text.sentence_2.part3",
            infoTextThirdSentence: "workflow_settings.info_text.sentence_3",
        };
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/workflowSettings/InfoContent.js